/*
 * @Author: wangbaihe
 * @Date: 2023-07-31 13:59:59
 * @LastEditors: wangbaihe
 * @LastEditTime: 2024-01-11 12:06:09
 * @FilePath: \common-mediax\src\apis\MediaCloudSystem\Menu.js
 * @Description: MediaCloudSystemOrg
 */
import { createAPI } from '@common'
export default {
  getGroupsMods: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0hspvqt0npet', 'GET', config),
  getMenuGroups: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0nfov0hspvq', 'GET', config),
  postMenuGroups: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0nfov0hspvq', 'POST', config),
  deleteMenuGroups: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0nfov0hspvq', 'DELETE', config),
  getMenuTree: (config) => createAPI('customEncryptApiName-1/0nfejby.tztufn0nfov0usff', 'GET', config),
  postMenu: (config) => createAPI('customEncryptApiName-1/0nfejby.tztufn0nfov', 'POST', config),
  deleteMenu: (config) => createAPI('customEncryptApiName-1/0nfejby.tztufn0nfov', 'DELETE', config),
  postMenuSorting: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0nfov0tpsujoh', 'POST', config),
  getSystemSync: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0nfov0tzod', 'GET', config),
  getPermission: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0npet0qfsnjttjpo', 'GET', config),
  // 查看某个角色是否具有某个模块的权限
  hasPermission: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0ibtQfsnjttjpo', 'GET', config),
  // 恢复初始化菜单配置(不管那个之全部还原
  postMenuGroupsInit: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0nfov0joju', 'POST', config)
}
